var store_language = window.Shopify.locale;

/*** To get Cutomer Id / Shop Domain / Session Id For Wishlist***/
const shop_domain = window.Shopify.shop;   

var gemfind_session_id = document.cookie.match(/gemfind_sessionId=([^;]*)/);

if(gemfind_session_id == undefined || gemfind_session_id == null){
  var user_session_id = '';
}else{
  var user_session_id = gemfind_session_id[1];
}
const session_id = user_session_id;

var customerid = __st.cid;
if(customerid == undefined || customerid == null){
  var customerid = '';
}
const customer_id = customerid;
/*** End ***/

getWishlistProductsCount();

/*** Get All Wishlist Active Products Using API ***/
function getAllWishlistProducts(){   
  
  var data = {
    "customer_id" : customer_id,
    "product_id" : "",
    "session_id" : session_id,
    "shop_domain" : shop_domain
  };
  var post_data = JSON.stringify(data);

  jQuery.ajax({
    url: 'https://gfwishlist.com/api/myWishlist',
    type: 'post',
    async: 'false',
    data: post_data,
    dataType: 'json',
    success: function(response){
      var status = response.status;
      if(status == 'success'){
        var product_data = response.data.wishlist_status;
        
        if(product_data.length > 0){
          $.each(product_data, function(i, wishlist_prod) {
            jQuery(".tps_wishlist_"+wishlist_prod.id).addClass("active"); //add class active to wishlist product
          });
        }
      
      }        
    }
  });
}
/*** End ***/

/*** Get All Wishlist Active Products Using API ***/
function checkProductInWhishlist(product_id){ 
  var data = {
    "customer_id" : customer_id,
    "product_id" : product_id,
    "session_id" : session_id,
    "shop_domain" : shop_domain
  };
  var post_data = JSON.stringify(data);

  jQuery.ajax({
    url: 'https://gfwishlist.com/api/productInWishlist',
    type: 'post',
    async: 'false',
    data: post_data,
    dataType: 'json',
    success: function(response){
      var status = response.status;
      if(status == 'success'){
        var product_data = response.data.wishlist_status;        
        if(product_data == true){   
            jQuery(".tps_wishlist_"+product_id).addClass("active"); //add class active to wishlist product        
        }      
      }        
    }
  });
}
/*** End ***/

/*** Onclick Wishlist Button Functionality  ***/ 
$(document).on("click", ".tps_wishlist_icon", function() {    
  var product_id = $(this).attr("data-product-id");
  var product_name = $(this).attr("data-product-name"); 
 
  var data = {
    "customer_id" : customer_id,
    "product_id" : product_id,
    "session_id" : session_id,
    "shop_domain" : shop_domain
  };
  var post_data = JSON.stringify(data);
  
  if(jQuery(".tps_wishlist_"+product_id).hasClass("active")){  
    if(store_language == 'de'){
      var message = "von der Wishlist entfernt.";
    }else{
      var message = "removed from Wishlist.";
    }
    gemFindWishlistAddRemove(post_data,product_name,product_id,message,'remove');
  }else{
    if(store_language == 'de'){
      var message = "zur Wishlist hinzugefügt.";
    }else{
      var message = "added to Wishlist.";
    }
    gemFindWishlistAddRemove(post_data,product_name,product_id,message,'add');
  }     
});
/*** End ***/ 

/*** Add & Remove Product From Wishlist ***/
function gemFindWishlistAddRemove(post_data,product_name,product_id,message,wishlist_flag){
  jQuery(".tps_wishlist_loader_"+product_id).addClass("tps_wishlist_loader_show");
  
  if(wishlist_flag == 'add'){
    var wishlist_url = "https://gfwishlist.com/api/addToWishlist";
  }else{
    var wishlist_url = "https://gfwishlist.com/api/removeWishlist";
  }
  
  jQuery.ajax({
    url: wishlist_url,
    type: 'post',
    async: 'false',
    data: post_data,
    dataType: 'json',
    success: function(response){
      var status = response.status;
      if(status == 'success'){
        if(wishlist_flag == 'add'){
          jQuery(".tps_wishlist_"+product_id).addClass("active");
        }else{
          jQuery(".tps_wishlist_"+product_id).removeClass("active");
        }
        jQuery(".tps_wishlist_loader_"+product_id).removeClass("tps_wishlist_loader_show");
        jQuery(".tps_wishlist_toast_msg_popup_wrapper").addClass("tps_popoup_show");
        jQuery('.tps_wishlist_toast_msg_content').html(product_name+' '+message);
        setTimeout(function() { $(".tps_wishlist_toast_msg_popup_wrapper").removeClass('tps_popoup_show'); }, 2000);

        getWishlistProductsCount();
      }        
    }
  });
}
/*** End ***/

/*** Get Wishlist Product Count ***/
function getWishlistProductsCount() {
  var data = {
    "customer_id" : customer_id,
    "product_id" : "",
    "session_id" : session_id,
    "shop_domain" : shop_domain
  };
  var post_data = JSON.stringify(data);

  jQuery.ajax({
    url: 'https://gfwishlist.com/api/myWishlist',
    type: 'post',
    async: 'false',
    data: post_data,
    dataType: 'json',
    success: function(response){
      var status = response.status;
      if(status == 'success'){
        var product_data = response.data.wishlist_status;
        var product_count = product_data.length;
        jQuery('.tps_wishlist_count').html(product_count);
      }        
    }
  });
}
/*** End ***/